// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const v = theme.vars.palette;
  return {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 6,
          letterSpacing: 0,
          lineHeight: 1.4,
          '&:focus-visible': { outline: `2px solid ${withAlpha(v.primary.main, 0.5)}`, outlineOffset: 2 }
        },
        sizeSmall: { padding: '4px 11px', fontSize: '0.8125rem' },
        sizeMedium: { padding: '6px 14px', fontSize: '0.8125rem', minHeight: 34 },
        sizeLarge: { padding: '10px 22px', fontSize: '0.9375rem' },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': { backgroundColor: v.primary.dark }
        },
        containedSecondary: {
          backgroundColor: v.grey[100],
          color: v.grey[800],
          '&:hover': { backgroundColor: v.grey[200] }
        },
        outlined: { borderColor: v.grey[300], color: v.grey[800], backgroundColor: v.background.paper },
        outlinedPrimary: {
          borderColor: withAlpha(v.primary.main, 0.45),
          color: v.primary.main,
          '&:hover': { backgroundColor: v.primary.lighter, borderColor: v.primary.main }
        },
        outlinedSecondary: { borderColor: v.grey[300], color: v.grey[800], '&:hover': { backgroundColor: v.grey[50], borderColor: v.grey[400] } },
        text: { '&:hover': { backgroundColor: v.grey[100] } },
        textPrimary: { '&:hover': { backgroundColor: v.primary.lighter } },
        // disabled state: clearly greyed, never the solid brand colour
        contained: { '&.Mui-disabled': { backgroundColor: v.grey[200], color: v.grey[400] } }
      }
    }
  };
}
